import axios from 'axios'

const jupApi = axios.create({
  baseURL: 'https://api.jup.ag/',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default jupApi
